/** Viewport width at or below = compact laptop layout (auto sidebar, quote workspace defaults). */
export const COMPACT_DESKTOP_MAX_PX = 1280;

/** Match short laptop heights (e.g. 720p, 600px chrome) in CSS: `[@media(max-height:720px)]:`. */
export const SHORT_VIEWPORT_MAX_HEIGHT_PX = 720;

/**
 * Operator split-pane QA targets (width × height). UI uses Tailwind:
 * - max-[1280px]: includes 1280-wide (1280×828/800)
 * - max-lg: <1024px (1024×663/640)
 * - max-[960px]: narrowest column (960×600)
 * 1440×932/900 stay on the default (roomier) scale.
 */
export const OPERATOR_LISTING_REFERENCE_VIEWPORTS = [
  [1440, 932],
  [1440, 900],
  [1280, 828],
  [1280, 800],
  [1024, 663],
  [1024, 640],
  [960, 600],
];

export function isCompactDesktopViewport() {
  if (typeof window === "undefined") return false;
  return window.innerWidth <= COMPACT_DESKTOP_MAX_PX;
}

export function isWiderThanCompactDesktop() {
  if (typeof window === "undefined") return true;
  return window.innerWidth > COMPACT_DESKTOP_MAX_PX;
}
